import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signIn } from '../../../store/actions/authActions';
import { withRouter, Redirect, NavLink } from 'react-router-dom';

//components
import { signInWithGoogle } from '../../../config/signInWithGoogle';
import GoogleButton from 'react-google-button';

//logo
import logo from '../../../images/bound_bleu_logo.png'
import happyOffice from '../../../images/happy_office.jpg'


class SingIn extends Component {

  state = {
    email: '',
    password: '',
  }

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value
      })
  }

  handleSubmit = (e) => {
      e.preventDefault();
      //this.props.signIn(this.state);
      if(this.state.email.includes("gmail")){
          signInWithGoogle()
      }else{
          this.props.signIn(this.state);
      }
  }

  render() {
    const { auth, authError } = this.props;

    if (auth.uid) {return <Redirect to='/' />}
    return (
      <div className="min-h-screen bg-white flex">
        <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img
                className="h-12 w-auto"
                src={logo}
                alt="Bound"
              />
              <h2 className="mt-8 text-3xl font-semibold text-gray-900">Sign in to your account</h2>
            </div>
  
            <div className="mt-8">
              <div>
                <div>
                  <p className="text-sm font-medium text-gray-700 mb-4">Sign in with</p>
  
                  <div className="mt-1 grid grid-cols-3 gap-3">
                    <div>
                      <GoogleButton 
                        type="dark" 
                        onClick={signInWithGoogle}
                        style={{ 
                            //marginTop: 20, 
                            //marginBottom: 20,
                            borderRadius: '3px',
                            backgroundColor: '#4F46E5',
                            color: 'white'
                        }}
                      />
                    </div><div>
                    </div><div>
                    </div>
                  </div>
                </div>
  
                <div className="mt-6 relative">
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="w-full border-t border-gray-300" />
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-gray-500">Or continue with</span>
                  </div>
                </div>
              </div>
  
              <div className="mt-6">
                <form action="#" method="POST" className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      Email address
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
  
                  <div className="space-y-1">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
  
                  <div className="flex items-center justify-between">
                    <div className="text-sm">
                      <NavLink
                        className="font-medium text-indigo-600 hover:text-indigo-500"
                        exact
                        to='/resetPassword'
                        >
                           Reset password 
                        </NavLink>
                    </div>

                    <div className="text-sm">
                        <NavLink
                        className="font-medium text-indigo-600 hover:text-indigo-500"
                        exact
                        to='/signUp'
                        >
                            Don't have a Bound account yet?  
                        </NavLink>
                    </div>
                  </div>
  
                  <div>
                    <button
                      type="submit"
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={this.handleSubmit}
                    >
                      Sign in
                    </button>
                  </div>
                </form>
                <div>
                  { authError ? <p style={{color: 'red', fontSize: '20px'}}> {authError} </p> : null }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            alt=""
            src={happyOffice}
          />
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
      authError: state.auth.authError,
      auth: state.firebase.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
      signIn: (creds) => dispatch(signIn(creds))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SingIn))